import React from 'react';
import './index.scss';
import clsx from 'clsx';

const TextBox = ({ 
  name,
  val,
  onChange, 
  onInput,
  onCompositionEnd,
  maxLength,
  placeholder,
  inValid = false, 
  suggestText = false,
}) => {
  return (
    <>
      <input
        autoComplete="off"
        type="text" 
        name={name} 
        value={val} 
        onChange={onChange} 
        onInput={onInput}
        onCompositionEnd={onCompositionEnd}
        maxLength={maxLength} 
        placeholder={placeholder} 
        className={clsx({ inValid })}
        id={clsx({suggestText})}
      />
    </>
  );
};
export default TextBox;